import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import apiCall from "redux/services/apiCall";
import { CREATE_SUPPLIER, NEW_BOOKING } from "redux/services/apiTypes";

const initialState = {
  staffListBasedOnBookingLoading: false,
  staffListBasedOnBookingSuccess: false,
  staffListBasedOnBookingRes: null,
  staffListBasedOnBookingErr: null,
};

export const getStaffListBasedOnBooking = createAsyncThunk(
  "staff/list",
  async (payload, { fulfillWithValue, rejectWithValue }) => {
    const apiData = {
      type: `${NEW_BOOKING}${payload.id}/available-staffs/${payload.query}`,
      apiType: "GET",
    };
    try {
      let res = await apiCall(apiData);
      return fulfillWithValue(res);
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const getMoreStaffListBasedOnBooking = createAsyncThunk(
  "staff/moreList",
  async (payload, { fulfillWithValue, rejectWithValue }) => {
    const apiData = {
      type: `${NEW_BOOKING}${payload.id}/available-staffs/${payload.query}`,
      apiType: "GET",
    };
    try {
      let res = await apiCall(apiData);
      return fulfillWithValue(res);
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

const StaffListBasedOnBookingSlice = createSlice({
  name: "StaffListBasedOnBooking",
  initialState,
  reducers: {
    clearStaffListBasedOnBooking: (state, action) => {
      state.staffListBasedOnBookingLoading = false;
      state.staffListBasedOnBookingSuccess = false;
      state.staffListBasedOnBookingRes = null;
      state.staffListBasedOnBookingErr = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getStaffListBasedOnBooking.pending, (state) => {
        state.staffListBasedOnBookingLoading = true;
        state.staffListBasedOnBookingSuccess = false;
      })
      .addCase(getStaffListBasedOnBooking.fulfilled, (state, action) => {
        state.staffListBasedOnBookingLoading = false;
        state.staffListBasedOnBookingSuccess = true;
        state.staffListBasedOnBookingRes = action.payload;
      })
      .addCase(getStaffListBasedOnBooking.rejected, (state, action) => {
        state.staffListBasedOnBookingLoading = false;
        state.staffListBasedOnBookingSuccess = true;
        state.staffListBasedOnBookingErr = action.payload;
      })
      .addCase(getMoreStaffListBasedOnBooking.pending, (state) => {
        state.staffListBasedOnBookingLoading = true;
        state.staffListBasedOnBookingSuccess = false;
      })
      .addCase(getMoreStaffListBasedOnBooking.fulfilled, (state, action) => {
        let res = {
          count: action.payload.count,
          next: action.payload.next,
          previous: action.payload.previous,
          results: [
            ...state.staffListBasedOnBookingRes.results,
            ...action.payload.results,
          ],
        };
        state.staffListBasedOnBookingLoading = false;
        state.staffListBasedOnBookingSuccess = true;
        state.staffListBasedOnBookingRes = res;
      })
      .addCase(getMoreStaffListBasedOnBooking.rejected, (state, action) => {
        state.staffListBasedOnBookingLoading = false;
        state.staffListBasedOnBookingSuccess = true;
        state.staffListBasedOnBookingErr = action.payload;
      });
  },
});

export const { clearStaffListBasedOnBooking } =
  StaffListBasedOnBookingSlice.actions;

export default StaffListBasedOnBookingSlice.reducer;
